import React, { useState } from "react";
import { Link } from "react-router-dom";

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLabsOpen, setIsLabsOpen] = useState(false);
  const [isCreativeLabMobileOpen, setIsCreativeLabMobileOpen] = useState(false);
  const [isIntelligenceLabMobileOpen, setIsIntelligenceLabMobileOpen] =
    useState(false);

  return (
    <nav className="fixed w-full z-50 top-0 left-0 px-4 sm:px-6 py-2 sm:py-3 flex justify-between items-center backdrop-blur-sm bg-background-light/80 dark:bg-background-dark/80 transition-all border-b border-gray-200 dark:border-gray-800">
      <Link to="/" className="flex items-center z-50">
        {/* Logo modo claro — se oculta en dark mode */}
        <img
          src="/logo.png"
          alt="Antagonista"
          className="h-9 sm:h-10 dark:hidden"
        />
        {/* Logo modo oscuro — se oculta en light mode */}
        <img
          src="/logo-white.png"
          alt="Antagonista"
          className="h-9 sm:h-10 hidden dark:block"
        />
      </Link>
      <div className="hidden lg:flex items-center gap-8">
        <Link
          to="/about"
          className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
        >
          Manifiesto
        </Link>

        {/* Labs Dropdown */}
        <div
          className="group relative"
          onMouseEnter={() => setIsLabsOpen(true)}
          onMouseLeave={() => setIsLabsOpen(false)}
        >
          <button className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 flex items-center gap-1 cursor-pointer">
            Labs
            <span className="material-icons text-sm">arrow_drop_down</span>
          </button>

          {/* Dropdown Menu - Con padding extra para no perder el hover */}
          <div
            className={`absolute top-full left-1/2 -translate-x-1/2 pt-6 transition-all duration-300 ${isLabsOpen ? "opacity-100 visible translate-y-0" : "opacity-0 invisible -translate-y-2 pointer-events-none"}`}
          >
            <div className="relative bg-white dark:bg-[#0f0f0f] border border-gray-100 dark:border-gray-800 rounded-xl shadow-glass overflow-hidden w-[800px]">
              {/* Background decorations */}
              <div className="absolute top-0 right-0 w-full h-full overflow-hidden pointer-events-none z-0">
                <div
                  className="absolute -top-24 -right-24 w-64 h-64 bg-accent/10 rounded-full"
                  style={{ filter: "blur(64px)" }}
                ></div>
                <div
                  className="absolute bottom-[-10%] right-[20%] w-48 h-48 bg-purple-500/5 rounded-full"
                  style={{ filter: "blur(64px)" }}
                ></div>
                <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent dark:from-white/5 dark:to-transparent opacity-50"></div>
              </div>

              <div className="relative z-10 grid grid-cols-12 min-h-[320px]">
                {/* Left Section - Servicios Button */}
                <div className="col-span-4 bg-gray-50/50 dark:bg-white/5 p-8 flex flex-col justify-center border-r border-gray-100 dark:border-gray-800">
                  <div className="mb-6">
                    <h3 className="font-display text-2xl mb-3 text-black dark:text-white">
                      Estructura
                    </h3>
                    <p className="font-body text-xs leading-relaxed text-gray-500 dark:text-gray-400">
                      Explora nuestra estructura completa de servicios y
                      metodología de trabajo.
                    </p>
                  </div>
                  <Link to="/services">
                    <button className="w-full bg-gray-900 dark:bg-gray-100 text-white dark:text-black hover:bg-accent dark:hover:bg-accent hover:text-white px-6 py-4 font-mono text-[10px] uppercase tracking-[0.2em] transition-all duration-300 flex items-center justify-between gap-4 group/btn">
                      <span>Ver Servicios</span>
                      <span className="material-icons text-sm group-hover/btn:translate-x-1 transition-transform">
                        arrow_forward
                      </span>
                    </button>
                  </Link>
                </div>

                {/* Right Section - Labs */}
                <div className="col-span-8 p-8 grid grid-cols-2 gap-6">
                  {/* Creative Lab */}
                  <div className="flex flex-col">
                    <div className="flex items-center gap-2 mb-6 border-b border-gray-100 dark:border-gray-800 pb-2">
                      <span className="w-1.5 h-1.5 bg-accent rounded-full"></span>
                      <h4 className="font-mono text-[10px] uppercase tracking-widest font-bold text-gray-900 dark:text-white">
                        Creative Lab
                      </h4>
                    </div>
                    <ul className="space-y-3 mb-6 flex-grow">
                      <li>
                        <Link
                          to="/creative-lab/branding-naming"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-accent dark:hover:text-accent hover:translate-x-1 transition-all duration-200"
                        >
                          Branding & Naming
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/creative-lab/creative-campaigns"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-accent dark:hover:text-accent hover:translate-x-1 transition-all duration-200"
                        >
                          Creative Campaigns
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/creative-lab/social-media-ads"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-accent dark:hover:text-accent hover:translate-x-1 transition-all duration-200"
                        >
                          Social Media Ads
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/creative-lab/web-experiences"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-accent dark:hover:text-accent hover:translate-x-1 transition-all duration-200"
                        >
                          Web Experiences
                        </Link>
                      </li>
                    </ul>
                    <Link to="/creative-lab" className="mt-auto">
                      <button className="w-full bg-black dark:bg-white text-white dark:text-black hover:bg-accent dark:hover:bg-accent hover:text-white px-6 py-3 font-mono text-[10px] uppercase tracking-[0.2em] transition-all duration-300 flex items-center justify-between gap-4 group/btn">
                        <span>Explore Lab</span>
                        <span className="material-icons text-sm group-hover/btn:translate-x-1 transition-transform">
                          arrow_forward
                        </span>
                      </button>
                    </Link>
                  </div>

                  {/* Intelligence Lab */}
                  <div className="flex flex-col">
                    <div className="flex items-center gap-2 mb-6 border-b border-gray-100 dark:border-gray-800 pb-2">
                      <span className="w-1.5 h-1.5 bg-indigo-500 rounded-full"></span>
                      <h4 className="font-mono text-[10px] uppercase tracking-widest font-bold text-gray-900 dark:text-white">
                        Intelligence Lab
                      </h4>
                    </div>
                    <ul className="space-y-3 mb-6 flex-grow">
                      <li>
                        <Link
                          to="/intelligence-lab/ai-consulting"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-indigo-500 dark:hover:text-indigo-400 hover:translate-x-1 transition-all duration-200"
                        >
                          AI Consulting
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/intelligence-lab/chatbots-assistants"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-indigo-500 dark:hover:text-indigo-400 hover:translate-x-1 transition-all duration-200"
                        >
                          Chatbots & Assistants
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/intelligence-lab/hr-optimization"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-indigo-500 dark:hover:text-indigo-400 hover:translate-x-1 transition-all duration-200"
                        >
                          HR Optimization
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/intelligence-lab/lead-automation"
                          className="block font-display text-lg text-gray-600 dark:text-gray-300 hover:text-indigo-500 dark:hover:text-indigo-400 hover:translate-x-1 transition-all duration-200"
                        >
                          Lead Automation
                        </Link>
                      </li>
                    </ul>
                    <Link to="/intelligence-lab" className="mt-auto">
                      <button className="w-full bg-accent text-white px-6 py-3 font-mono text-[10px] uppercase tracking-[0.2em] transition-all duration-300 hover:bg-black dark:hover:bg-white dark:hover:text-black flex items-center justify-between gap-4 group/btn shadow-lg shadow-accent/20">
                        <span>Book Audit</span>
                        <span className="material-icons text-sm group-hover/btn:translate-x-1 transition-transform">
                          bolt
                        </span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Link
          to="/portfolio"
          className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
        >
          Portfolio
        </Link>
        <Link
          to="/pricing"
          className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
        >
          Pricing
        </Link>
        <Link
          to="/methodology"
          className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
        >
          Metodología
        </Link>
        <Link
          to="/blog"
          className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
        >
          Blog
        </Link>
        <Link
          to="/contact"
          className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
        >
          Contacto
        </Link>
      </div>

      {/* Mobile menu button */}
      <button
        className="lg:hidden p-2 z-50 relative"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle menu"
      >
        <span className="material-icons text-xl">
          {isMobileMenuOpen ? "close" : "menu"}
        </span>
      </button>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 bg-background-light dark:bg-background-dark border-b border-gray-200 dark:border-gray-800 lg:hidden shadow-lg max-h-[calc(100vh-80px)] overflow-y-auto">
          <div className="flex flex-col gap-4 p-6 pb-8">
            <Link
              to="/about"
              className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Manifiesto
            </Link>

            {/* Servicios Generales */}
            <div className="border-l-2 border-accent pl-4 space-y-2">
              <p className="font-mono text-[10px] uppercase tracking-wider text-accent font-bold mb-2">
                Servicios
              </p>
              <Link
                to="/services"
                className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Ver Todos los Servicios
              </Link>
            </div>

            {/* Creative Lab Accordion */}
            <div className="border-l-2 border-accent pl-4 space-y-2">
              <button
                onClick={() =>
                  setIsCreativeLabMobileOpen(!isCreativeLabMobileOpen)
                }
                className="w-full flex items-center justify-between font-mono text-[10px] uppercase tracking-wider text-accent font-bold"
              >
                <span>Creative Lab</span>
                <span
                  className="material-icons text-sm transition-transform duration-200"
                  style={{
                    transform: isCreativeLabMobileOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  expand_more
                </span>
              </button>

              {/* Creative Lab Links */}
              <div
                className={`space-y-2 overflow-hidden transition-all duration-300 ${isCreativeLabMobileOpen ? "max-h-96 opacity-100 mt-2" : "max-h-0 opacity-0"}`}
              >
                <Link
                  to="/creative-lab"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 text-gray-600 dark:text-gray-400 pl-3 border-l border-gray-300 dark:border-gray-700"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  → Ver Creative Lab
                </Link>
                <Link
                  to="/creative-lab/branding-naming"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Branding & Naming
                </Link>
                <Link
                  to="/creative-lab/creative-campaigns"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Creative Campaigns
                </Link>
                <Link
                  to="/creative-lab/social-media-ads"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Social Media Ads
                </Link>
                <Link
                  to="/creative-lab/web-experiences"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Web Experiences
                </Link>
              </div>
            </div>

            {/* Intelligence Lab Accordion */}
            <div className="border-l-2 border-indigo-500 pl-4 space-y-2">
              <button
                onClick={() =>
                  setIsIntelligenceLabMobileOpen(!isIntelligenceLabMobileOpen)
                }
                className="w-full flex items-center justify-between font-mono text-[10px] uppercase tracking-wider text-indigo-500 font-bold"
              >
                <span>Intelligence Lab</span>
                <span
                  className="material-icons text-sm transition-transform duration-200"
                  style={{
                    transform: isIntelligenceLabMobileOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  expand_more
                </span>
              </button>

              {/* Intelligence Lab Links */}
              <div
                className={`space-y-2 overflow-hidden transition-all duration-300 ${isIntelligenceLabMobileOpen ? "max-h-96 opacity-100 mt-2" : "max-h-0 opacity-0"}`}
              >
                <Link
                  to="/intelligence-lab"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 text-gray-600 dark:text-gray-400 pl-3 border-l border-gray-300 dark:border-gray-700"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  → Ver Intelligence Lab
                </Link>
                <Link
                  to="/intelligence-lab/ai-consulting"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  AI Consulting
                </Link>
                <Link
                  to="/intelligence-lab/chatbots-assistants"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Chatbots & Assistants
                </Link>
                <Link
                  to="/intelligence-lab/hr-optimization"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  HR Optimization
                </Link>
                <Link
                  to="/intelligence-lab/lead-automation"
                  className="block font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1 pl-3"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Lead Automation
                </Link>
              </div>
            </div>

            <Link
              to="/portfolio"
              className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Portfolio
            </Link>
            <Link
              to="/pricing"
              className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link
              to="/methodology"
              className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Metodología
            </Link>
            <Link
              to="/blog"
              className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              to="/contact"
              className="font-mono text-xs uppercase hover:underline underline-offset-4 decoration-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contacto
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};
